import React from 'react'
import { Skeleton as MuSkeleton } from '@mui/material';
import { Container, SkeletonColumn, SkeletonHeader, SkeletonRow } from './styles'

export const Skeleton = ({columnsSize}) => {
  const headerTextWidth = [156, 76, 172, 172, 100];
  const rowTextWidth = [280, 120, 280, 120, 120];
  return (
    <Container>
      <SkeletonHeader>
        {
          columnsSize.map((column, id) => (
            <SkeletonColumn key={id} width={column.width}>
              <MuSkeleton
                variant="text"
                height="14px"
                width={`${headerTextWidth[id]}px`}
                animation="wave"
              />
            </SkeletonColumn>
          ))
        }
      </SkeletonHeader>
      {Array.from({ length: 8 }).map((_, id) => (
        <SkeletonRow key={id}>
          {
          columnsSize.map((column, id) => (
            <SkeletonColumn key={id} width={column.width}>
              <MuSkeleton
                variant="text"
                height="14px"
                width={`${rowTextWidth[id]}px`}
                animation="wave"
              />
            </SkeletonColumn>
          ))
        }
        </SkeletonRow>
      ))}
    </Container>
  )
}
